import type { Partner } from "@expert/shared-types";
import type { JSX } from "react";

import { useVerifiedCustomerStore } from "../../../../../stores";
import { SaleProgress } from "../../../../../types";
import { ATTIcon } from "./icons/ATTIcon";
import { OptimumIcon } from "./icons/OptimumIcon";
import { VerizonIcon } from "./icons/VerizonIcon";
import classes from "./PlanCard.module.css";

export function determineCardStyle(saleProgress: SaleProgress | undefined) {
    if (saleProgress === SaleProgress.Success) {
        return classes.enrolled;
    } else if (saleProgress === SaleProgress.Declined) {
        return classes.declined;
    }
}

export function getPartnerIcon(partner: string): JSX.Element | null {
    switch (partner) {
        case "verizon":
        case "fios":
            return <VerizonIcon />;
        case "att":
            return <ATTIcon />;
        case "optimum":
            return <OptimumIcon />;
        default:
            return null;
    }
}

export function showRecommended(partner: Partner, productSku: string, sessionId: string): boolean {
    if (partner !== "youtubetv") return true;

    // YouTube TV specific logic
    const { customer } = useVerifiedCustomerStore.getState().getVerifiedCustomer(sessionId);
    const currentSubscriptions = customer?.currentSubscriptions;
    const hasYouTubeTV = currentSubscriptions?.includes("YouTube TV");
    const hasNFLSundayTicket = currentSubscriptions?.includes("NFL Sunday Ticket");

    return (hasYouTubeTV && hasNFLSundayTicket) || !(productSku === "STREAMING" || productSku === "GOOG_SUNDAYTICKET");
}
